import { create } from 'zustand';

interface ActiveModel {
  id: number;
  name: string;
}

interface ImageViewerStore {
  isOpen: boolean;
  imageUrl: string | null;
  activeModel: ActiveModel | null;
  isNSFW: boolean;
  prompt: string | null;
  openImage: (url: string, model?: ActiveModel, isNSFW?: boolean, prompt?: string | null) => void;
  closeImage: () => void;
}

export const useImageViewerStore = create<ImageViewerStore>((set) => ({
  isOpen: false,
  imageUrl: null,
  activeModel: null,
  isNSFW: false,
  prompt: null,
  openImage: (url, model = undefined, isNSFW = false, prompt = null) =>
    set({ isOpen: true, imageUrl: url, activeModel: model, isNSFW, prompt }),
  closeImage: () =>
    set({ isOpen: false, imageUrl: null, activeModel: null, isNSFW: false, prompt: null }),
}));
